var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UserService } from '../user.service';
import { CredentialsService } from '../credentials.service';
import { User } from '../../classes/user';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { ApiService } from '../api.service';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserPreferences } from '../../classes/user-preferences';
import { environment } from '../../../environments/environment-wrapper';
import { RECAPTCHA_HEADER } from '../../classes/leads';
var BrowserUserService = /** @class */ (function (_super) {
    __extends(BrowserUserService, _super);
    function BrowserUserService(appConfig, http, apiService, credentialsService) {
        var _this = _super.call(this) || this;
        _this.appConfig = appConfig;
        _this.http = http;
        _this.apiService = apiService;
        _this.credentialsService = credentialsService;
        _this._localCacheKey = 'dotca_user';
        _this._currentUser = new BehaviorSubject(null);
        // We get a notification that someone just logged in or out, update the currentUser as appropriate.
        _this.addSub(_this.credentialsService.isLoggedIn.subscribe(function (isAuthenticated) {
            if (isAuthenticated) {
                _this.getUserFromDb().then(function (response) {
                    var user = new User(JSON.parse(JSON.parse(response).result));
                    // Plug in the email address from their access token.
                    user.email = _this.credentialsService.getEmailFromAccessToken();
                    _this._currentUser.next(user);
                });
            }
            else {
                // Otherwise clear their user and load from local.
                _this.getUserFromLocal();
            }
        }));
        _this.addStorageEventListener();
        return _this;
    }
    BrowserUserService.prototype.checkIfAlreadyLoggedIn = function () {
        // The credentialService will either find a valid access token and kick off isLoggedIn = true, or it won't and we will
        // try to get a new one with the refresh token. It that is successful, the credentialsService will again kick of isLoggedIn = true.
        if (!this.credentialsService.isAccessTokenValid()) {
            this.apiService.getRefreshAccessToken().toPromise();
        }
    };
    BrowserUserService.prototype.saveUser = function (user) {
        if (user) {
            return this.saveUserToStorage(user, true);
        }
    };
    BrowserUserService.prototype.saveUserPreferences = function (preferences) {
        var user = this._currentUser.getValue();
        user.preferences = preferences;
        this.saveUserToStorage(user, false);
    };
    BrowserUserService.prototype.registerUser = function (registration, recaptchaKey) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        headers = new HttpHeaders((_a = {}, _a[RECAPTCHA_HEADER] = recaptchaKey, _a));
                        return [4 /*yield*/, this.http.post(environment.baseServerUrl + this.appConfig.urls.user.base, registration, { headers: headers })
                                .toPromise()];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    BrowserUserService.prototype.checkUserAccounts = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = new HttpParams()
                            .set('email', email);
                        return [4 /*yield*/, this.http.get(environment.baseServerUrl + this.appConfig.urls.user.accounts, { params: params })
                                .pipe(map(function (res) { return res.result; })).toPromise()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BrowserUserService.prototype.removeLocalUser = function () {
        window.localStorage.removeItem(this._localCacheKey);
        this._currentUser.next(new User());
    };
    BrowserUserService.prototype.isGoogleBot = function () {
        return navigator.userAgent.indexOf('Googlebot') >= 0;
    };
    BrowserUserService.prototype.getLocalSavedSearches = function () {
        var storedUserString = window.localStorage.getItem(this._localCacheKey);
        if (storedUserString !== null) {
            var storedUser = this.getStoredUser(storedUserString);
            return storedUser.preferences.savedSearches;
        }
        else {
            return null;
        }
    };
    Object.defineProperty(BrowserUserService.prototype, "currentUser", {
        get: function () {
            {
                if (!this._currentUser.value) {
                    this.getUserFromLocal();
                }
                return this._currentUser;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Calls the backend to get the user and all associated data for the currently logged in user.
     */
    BrowserUserService.prototype.getUserFromDb = function () {
        return this.apiService.getRequest(this.appConfig.urls.user.base)
            .build()
            .pipe(map(function (result) {
            if (result.error) { }
            return result.response;
        })).toPromise();
    };
    BrowserUserService.prototype.getUserFromLocal = function () {
        var storedUserString = window.localStorage.getItem(this._localCacheKey);
        if (storedUserString !== null) {
            var storedUser = this.getStoredUser(storedUserString);
            this._currentUser.next(new User(storedUser));
        }
        else {
            this._currentUser.next(new User());
        }
    };
    BrowserUserService.prototype.getStoredUser = function (storedUserString) {
        var storedUser = new User(JSON.parse(storedUserString));
        // Check if the version of data is old and we need to blow it all away and start fresh.
        if (storedUser.preferences.storedVersionNumber !== UserPreferences.latestVersionNumber) {
            window.localStorage.clear();
            storedUser = new User();
        }
        return storedUser;
    };
    BrowserUserService.prototype.saveUserToStorage = function (user, notifyOfChange) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // TODO: add in a fallback for cookie based saving if safari private
                        window.localStorage.setItem(this._localCacheKey, JSON.stringify(user));
                        if (!user.email) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiService.postRequest(this.appConfig.urls.user.save, user)
                                .disableAutomaticRedirectToLogin()
                                .build()
                                .pipe(map(function (result) {
                                if (result.response) {
                                    window.localStorage.setItem(_this._localCacheKey, result.response);
                                    var updatedUser = new User(JSON.parse(result.response));
                                    user.updatedByStorage = true;
                                    user.preferences.savedSearches = updatedUser.preferences.savedSearches;
                                    // this._currentUser..next(user);
                                }
                                return !!result.response;
                            })).toPromise()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (notifyOfChange) {
                            this._currentUser.next(user);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BrowserUserService.prototype.addStorageEventListener = function () {
        window.addEventListener('storage', this.storageEventListener.bind(this));
    };
    BrowserUserService.prototype.storageEventListener = function (event) {
        if (event.storageArea === localStorage && !!event.newValue && event.newValue !== 'test') {
            var user = new User(JSON.parse(event.newValue));
            var currentUser = this._currentUser.getValue();
            currentUser.updatedByStorage = true;
            currentUser.preferences.savedSearches = user.preferences.savedSearches;
            this._currentUser.next(currentUser);
        }
    };
    BrowserUserService.prototype.restoreSession = function (sessionCacheKey) {
        return this.apiService.restoreAccessToken(sessionCacheKey);
    };
    BrowserUserService.prototype.getSavedSearch = function (encryptedKey) {
        var params = new HttpParams().set('key', encryptedKey);
        return this.http.get(environment.baseServerUrl + this.appConfig.urls.user.retrieveSavedSearch, { params: params }).pipe(map(function (res) { return res.result; }));
    };
    BrowserUserService.prototype.unsubscribeSavedSearchNotifications = function (key) {
        var params = new HttpParams().set('key', key);
        return this.http.post(environment.baseServerUrl + this.appConfig.urls.user.unsubscribeSavedSearchNotification, null, { params: params }).pipe(map(function () { }));
    };
    return BrowserUserService;
}(UserService));
export { BrowserUserService };
